import React, {useState, useEffect, useCallback} from "react";
import Select from "../../components/Select";
import {IoAddCircleOutline} from "react-icons/io5";
import {createItem, deleteItem} from "../../services/service";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import DeleteButton from "../../components/DeleteButton";
import FillingDataTable from "../../components/FillingDataTable";
import Pagination from "../../components/Pagination";
import {useTranslation, withTranslation} from "react-i18next";
import swal from "sweetalert";
import ModalAddConnectionTypeSpecificationParameter
    from "../../components/connection/ModalAddConnectionTypeSpecificationParameter";
import {toast} from "react-toastify";
import TempDataTable from "../../components/TemDataTable";
import AddParamComponent from "../../components/addParamComponent/addParamComponent";
import EditButton from "../../components/EditButton";


const headerTable = [{
    name: "id", sort: false
}, {
    name: "name", sort: true
}, {
    name: "value", sort: true
}, <span className="sr-only">Edit</span>,];

const bodyTable = [
    "id",
    "specificationType",
    "value",
    "actions"
];

const ConnectionTypeSpecificationParameter = ({
                                                  selectedRowId,
                                                  specificationId,
                                              }) => {
    const navigate = useNavigate();
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [rowId, setRowId] = useState(null);
    const {token} = useSelector((state) => state.user);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);

    const fetchData = async () => {
        const response = await createItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/specification/parameter/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: "", regex: true},
                filter: {specificationId: specificationId},
            }
        );
        if (response.success) {
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: item.id,
                    specificationType: t(`${item.specificationType}`),
                    value: item.value,
                    actions: (
                        <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                            <EditButton onclick={() => editHandler(item.id)}/>
                            <DeleteButton onclick={() => handleDelete(item.id)}/>
                        </div>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        if (specificationId !== null) {
            fetchData();
        } else {
            setData({
                data: [],
                recordsTotal: 0,
                pageCount: 1,
            });
        }
    }, [
        selectedRowId,
        specificationId,
        itemOffset,
        itemsPerPage,
        data.recordsTotal,
    ]);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const handleDelete = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            const response = await deleteItem(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/connection/specification/parameter/${id}`,
                token
            );
            if (response.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    const editHandler = (id) => {
        setRowId(id)
        setOpen(true);
        setIsEdit(true);
    }
    const handleOpen = () => {
        setIsEdit(false)
        setOpen(true);
        setRowId(null)
    }
    const handleClose = useCallback(() => {
        setOpen(false);
        setIsEdit(false);
    }, [open]);

    const getDataAfterSaveHandler = useCallback(() => {
        fetchData()
    }, [specificationId])

    return (
        <>
            <AddParamComponent
                getDataAfterSaveHandler={getDataAfterSaveHandler}
                additionalId={specificationId}
                open={open}
                handleClose={handleClose}
                parentId={"specificationId"}
                enumType={'specificationType'}
                enumUrl={'/v1/connection/specification/parameter/enum/specification/type'}
                url={'/v1/connection/specification/parameter'}
                isEdit={isEdit}
                rowId={rowId}
            />
            {/*<ModalAddConnectionTypeSpecificationParameter
                open={open}
                setOpen={setOpen}
                specificationId={specificationId}
                fetchData={fetchData}
            />*/}
            <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">
                    {t(`table.connection.connection_type_specification_parameter`)}
                </h1>
            </div>
            <div className="flex items-center justify-between">
                <Select
                    setItemsPerPage={setItemsPerPage}
                    itemsPerPage={itemsPerPage}
                    specificationId={specificationId}
                />
                <button
                    className={`${
                        specificationId
                            ? "flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            : "cursor-no-drop flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-300 border border-transparent rounded-md shadow-sm "
                    }   `}
                    onClick={handleOpen}
                    disabled={specificationId ? false : true}
                >
                    {t('action.add')} {specificationId}
                    <IoAddCircleOutline className="w-4 h-4 ml-1"/>
                </button>
            </div>
            <TempDataTable
                data={data.data}
                headerTable={headerTable}
                bodyContent={bodyTable}
                sortFunction={sortFunction}
            />
            <Pagination
                handlePageClick={handlePageClick}
                pageCount={data.pageCount}
                forcePage={forcePage}
            />
        </>
    );
};

export default withTranslation()(ConnectionTypeSpecificationParameter);
